export default __webpack_public_path__ + "static/media/appimg.e9e3d01d.png";